import chalk from "chalk";
import ora from "ora";
import { ScenariosApiService } from "@/client-sdk/services/scenarios";
import type { ScenarioResponse } from "@/client-sdk/services/scenarios";
import { checkApiKey } from "../../utils/apiKey";
import { failSpinner } from "../../utils/spinnerError";

const formatScenarioDetails = (scenario: ScenarioResponse): void => {
  console.log();
  console.log(chalk.bold.cyan(scenario.name));
  console.log(chalk.gray("─".repeat(40)));

  console.log(`  ${chalk.gray("ID:")}        ${scenario.id}`);

  if (scenario.labels.length > 0) {
    console.log(
      `  ${chalk.gray("Labels:")}    ${scenario.labels.map((l) => chalk.yellow(l)).join(", ")}`,
    );
  }

  console.log();
  console.log(chalk.bold("  Situation:"));
  console.log(`    ${scenario.situation}`);

  if (scenario.criteria.length > 0) {
    console.log();
    console.log(chalk.bold("  Criteria:"));
    scenario.criteria.forEach((criterion) => {
      console.log(`    ${chalk.green("•")} ${criterion}`);
    });
  }

  if (scenario.platformUrl) {
    console.log(`  ${chalk.bold("View:")}  ${chalk.underline(scenario.platformUrl)}`);
  }

  console.log();
};

export const getScenarioCommand = async (id: string, options?: { format?: string }): Promise<void> => {
  checkApiKey();

  const service = new ScenariosApiService();
  const spinner = ora(`Fetching scenario "${id}"...`).start();

  try {
    const scenario = await service.get(id);
    spinner.succeed(`Found scenario "${scenario.name}"`);
    if (options?.format === "json") {
      console.log(JSON.stringify(scenario, null, 2));
      return;
    }
    formatScenarioDetails(scenario);
  } catch (error) {
    failSpinner({ spinner, error, action: "fetch scenario" });
    process.exit(1);
  }
};
